import { Component } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { LineGraphComponent } from "./line-graph/line-graph.component";
import { JiraResult } from "./jira-result";
import { HttpParams } from "@angular/common/http";
import { StatusType } from "./issue-type";
import { JiraDashboardService } from "./jira-dashboard.service";

@Component({
    selector: 'jira-dashboard',
    template: require('./jira-dashboard.html'),
    providers: [JiraDashboardService]
})

export class JiraDashboardComponent {

    private showCharts: boolean = false;
    private updating: boolean = false;
    private daysBack: number = 7;
    private daysBackFilter: number = 7;
    private createdResolvedData: Array<any> = this.emptyDataSet();
    private timeToResolutionData: Array<any> = this.emptyDataSet();
    private slaMetVsBreachedData: Array<any> = this.emptyDataSet();
    private requestTypesTicketsCreatedData: Array<any> = this.emptyDataSet();
    private openTicketsByAgentData: Array<any> = this.emptyDataSet();
    private closedTicketsByAgentData: Array<any> = this.emptyDataSet();
    private serviceRequestsBecomingChangeRequestsData: Array<any> = this.emptyDataSet();
    public createdTotal: number = 0;
    public duplicateTotal: number = 0;
    public resolvedTotal: number = 0;
    public breachedTotal: number = 0;
    public metTotal: number = 0;
    public requestTypeTotal: number = 0;
    public assigneeTotal: number = 0;

    public chartOptions: any = {
        xaxis: {
            mode: "time",
            minTickSize: [1, "day"]
        },
        yaxis: {
            min: 0
        },
    };
    public timeToResolutionOptions: any = {
        yaxis: {
            tickFormatter: (val) => Math.round((val / 3600000) * 10) / 10 + ' hrs',
            min: 0
        },
        xaxis: {
            mode: "time",
            minTickSize: [1, "day"]
        },
    }

    public constructor(
        private http: HttpClient,
        private jiraDashboardService: JiraDashboardService
    ) {
        this.loadCharts();
    }

    public loadCharts(): void {
        this.updating = true;
        this.daysBack = this.daysBackFilter;
        let self = this;
        this.http.post<Array<JiraResult>>(this.jiraDashboardService.url, {
            DaysBack: this.daysBack,
            ProjectNames: this.jiraDashboardService.projectNames,
            CurrentPage: 0,
            ItemsPerPage: -1
        }).subscribe(x => self.mapChartData(x), () => self.updating = false);
    }

    private mapChartData(response: Array<JiraResult>): void {
        this.setCreatedVsResolved(response);
        this.setTimeToResolution(response);
        this.setSlaMetVsBreached(response);
        this.setRequestTypesTicketsCreated(response);
        this.setOpenTicketsByAgent(response);
        this.setClosedTicketsByAgent(response);
        this.setServiceRequestsBecomingChangeRequests(response);
        this.showCharts = true;
        this.updating = false;
    }

    private setCreatedVsResolved(response: Array<JiraResult>): void {

        response = response.filter(x => x.issueTypeName == 'Service Request');
        let created = response.filter(x => x.statusName == StatusType.Canceled || x.statusName == StatusType.Closed || x.statusName == StatusType.InProgress || x.statusName == StatusType.Pending || x.statusName == StatusType.Resolved || x.statusName == StatusType.WaitingForCustomer || x.statusName == StatusType.WaitingForSupport);
        let resolved = response.filter(x => x.statusName == StatusType.Canceled || x.statusName == StatusType.Closed || x.statusName == StatusType.Resolved);
        let duplicate = response.filter(x => (x.statusName == StatusType.Canceled || x.statusName == StatusType.Closed || x.statusName == StatusType.Resolved) && x.resolutionName == 'Duplicate');
        let createdDataSet = new Array<any>();
        let resolvedDataSet = new Array<any>();
        let duplicateDataSet = new Array<any>();
        var totalCreated = 0;
        var totalResolved = 0;
        var totalDuplicate = 0;
        let daysBack = this.lastDaysBack();
        daysBack.forEach(day => {
            let createdCount: number = created.filter(x => x.createdShortDate == day).length;//
            let resolvedCount: number = resolved.filter(x => x.resolutionShortDate == day).length;
            let duplicateCount: number = duplicate.filter(x => x.updatedShortDate == day).length;
            let date = new Date(day);
            createdDataSet.push([date, createdCount]);
            resolvedDataSet.push([date, resolvedCount]);
            duplicateDataSet.push([date, duplicateCount]);
            totalCreated += createdCount;
            totalResolved += resolvedCount;
            totalDuplicate += duplicateCount;
        });

            this.createdTotal = totalCreated;
            this.resolvedTotal = totalResolved;
            this.duplicateTotal = totalDuplicate;

        this.createdResolvedData = new Array<any>();
        this.createdResolvedData.push({
            label: 'Created',
            data: createdDataSet
        });
        this.createdResolvedData.push({
            label: 'Resolved',
            data: resolvedDataSet
        });
        this.createdResolvedData.push({
            label: 'Duplicate',
            data: duplicateDataSet
        });
    }

    private setTimeToResolution(response: Array<JiraResult>): void {
        response = response.filter(x => x.issueTypeName == 'Service Request' && (x.statusName == StatusType.Canceled || x.statusName == StatusType.Closed || x.statusName == StatusType.Pending || x.statusName == StatusType.Resolved));
        this.filterByAssignee(response, 'timeToResolutionData', (series, day) => {
            let totalMiliseconds = response
                .filter(x => x.resolutionShortDate == day && x.assigneeName == series.label)
                .map(x => x.elapsedTime)
                .reduce((a, b) => a + b, 0);
            return totalMiliseconds;
        });
    }

    private setSlaMetVsBreached(response: Array<JiraResult>): void {
        response = response.filter(x => x.issueTypeName == 'Service Request' && (x.statusName == StatusType.Canceled || x.statusName == StatusType.Closed || x.statusName == StatusType.Escalated || x.statusName == StatusType.InProgress || x.statusName == StatusType.Pending || x.statusName == StatusType.Resolved || x.statusName == StatusType.WaitingForCustomer || x.statusName == StatusType.WaitingForSupport));
        let daysBack = this.lastDaysBack();
        let breachedDataSet = new Array<any>();
        let metDataSet = new Array<any>();
        var totalMet = 0;
        var totalBreached = 0;
        daysBack.forEach(day => {
            let breachCount: number = response.filter(x => x.breachDate == day).length;
            let metCount: number = response.filter(x => !x.breachDate && x.resolutionShortDate == day).length;
            let date = new Date(day);
            breachedDataSet.push([date, breachCount]);
            metDataSet.push([date, metCount])
            this.breachedTotal = breachCount;
            this.metTotal = metCount;

            totalMet += metCount;
            totalBreached += metCount;
        });
        this.metTotal = totalMet;
        this.breachedTotal = totalBreached;

        this.slaMetVsBreachedData = new Array<any>();
        this.slaMetVsBreachedData.push({
            label: 'Breached',
            data: breachedDataSet
        });
        this.slaMetVsBreachedData.push({
            label: 'Met',
            data: metDataSet
        });
    }

    private setRequestTypesTicketsCreated(response: Array<JiraResult>): void {
        response = response.filter(x => x.issueTypeName == 'Service Request');
        this.filterByRequestType(response);
    }

    private filterByRequestType(response: Array<JiraResult>): void {
        var totalRequestType = 0;
        let daysBack = this.lastDaysBack();
        this.requestTypesTicketsCreatedData = new Array<any>();
        let requestTypes = Array.from(new Set(response.map(x => x.requestTypeName)));
        requestTypes.forEach(requestTypeName => {
            this.requestTypesTicketsCreatedData.push({
                label: requestTypeName,
                data: [],
                total: this.requestTypeTotal
            });
        });
        daysBack.forEach(day => {
           
            let issues: Array<JiraResult> = response.filter(x => x.createdShortDate == day);//
            let date = new Date(day);
            this.requestTypesTicketsCreatedData.forEach(series => {
                let count: number = issues.filter(x => x.requestTypeName == series.label).length;
                totalRequestType += count;
                series.total += count;
                series.data.push([date, count]);              
            });
        });
       // this.requestTypeTotal =  totalRequestType;
    }

    private setOpenTicketsByAgent(response: Array<JiraResult>): void {
        response = response.filter(x => x.issueTypeName == 'Service Request' && (x.statusName == StatusType.Escalated || x.statusName == StatusType.InProgress || x.statusName == StatusType.Pending || x.statusName == StatusType.WaitingForCustomer || x.statusName == StatusType.WaitingForSupport));
        this.filterByAssignee(response, 'openTicketsByAgentData', (series, day) => {
            return response.filter(x => x.createdShortDate == day && x.assigneeName == series.label).length;//
        });
    }

    private setClosedTicketsByAgent(response: Array<JiraResult>): void {
        response = response.filter(x => x.issueTypeName == 'Service Request' && (x.statusName == StatusType.Canceled || x.statusName == StatusType.Closed || x.statusName == StatusType.Resolved));
        this.filterByAssignee(response, 'closedTicketsByAgentData', (series, day) => {
            return response.filter(x => x.resolutionShortDate == day && x.assigneeName == series.label).length;
        });
    }

    private filterByAssignee(response: Array<JiraResult>, seriesName: string, callback: Function): void {
        var assigneeTotal = 0;
        let daysBack = this.lastDaysBack();
        this[seriesName] = new Array<any>();
        let assigneeNames = Array.from(new Set(response.map(x => x.assigneeName)));
        if (assigneeNames.indexOf('nicol') == -1)
            assigneeNames.push('nicol');
        assigneeNames.forEach(assigneeName => {
            this[seriesName].push({
                label: assigneeName,
                data: [],
                total: this.assigneeTotal
            });
        });
        daysBack.forEach(day => {
            let date = new Date(day);
            this[seriesName].forEach(series => {
                let result: number = callback(series, day);
                assigneeTotal += result;
                series.total+= result;
                series.data.push([date, result]);    
            });
        });
    }

    private setServiceRequestsBecomingChangeRequests(response: Array<JiraResult>): void {
        console.log('setServiceRequestsBecomingChangeRequests not implemented');
    }

    private emptyDataSet(): Array<any> {
        let daysBack = this.lastDaysBack();
        return [{
            label: 'Empty',
            data: daysBack.map(day => [new Date(day), 0]),
            total: 0
        }];
    }

    private lastDaysBack(): Array<string> {
        let result = new Array<string>();
        for (let i = 0; i < this.daysBack; i++) {
            let d: Date = new Date();
            let formattedDate = this.formatDate(d);
            d.setDate(d.getDate() - i);
            result.push(this.formatDate(d));
        }
        return result.reverse();
    }

    private formatDate(date: Date): string {
        let dd: any = date.getDate();
        let mm: any = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10)
            dd = '0' + dd;
        if (mm < 10)
            mm = '0' + mm;
        return yyyy + '-' + mm + '-' + dd;
    }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dashboards/jira-dashboard.component.ts